import { getEnv, types } from "mobx-state-tree";
import { StorageModel } from "../storage/StorageModel";
import { endpoints } from "../api/ApiEndpoints";
import { api } from "../api/ApiService";
import { organizationSubscriptionService } from "../organization/OrganizationSubscription";
import { reaction } from "mobx";

export interface MainCodeColor {
    mainCode: string,
    color: string
}

const MainCodeColorStorageModel = types.compose(
    StorageModel,
    types.model({
        colors: types.optional(types.frozen<MainCodeColor[]>(), [])
    }).views((self) => ({
        get endpoint() {
            return endpoints.get("get_main_code_colors");
        },
        get isLoading() {
            // See StorageModel.loadAttempted. canLoadItems below needs the org subscription
            // key, so without the flag a missing organization wedges this on "loading" forever.
            if ((self as any).error || (self as any).loadAttempted) return false;
            return self.colors.length <= 0;
        },
        get canLoadItems() {
            const env: any = getEnv(self);
            return !!env?.organizationSubscriptionService?.key;
        },
    })).actions((self) => {
        return {
            mapResponse(response: MainCodeColor[]) {
                self.colors = response;
            },
        }
    })
)

export const mainCodeColorStorage = MainCodeColorStorageModel.create({}, { api, organizationSubscriptionService });

reaction(
    () => organizationSubscriptionService.key,
    async () => {
        await mainCodeColorStorage.load();
    }
);